<script setup>
import { usePolicy } from 'dashboard/composables/usePolicy';
import { useAcesso } from 'dashboard/composables/useAcesso';
import { computed } from 'vue';

const props = defineProps({
  as: {
    type: String,
    default: 'div',
  },
  permissions: {
    type: Array,
    required: true,
  },
  // ACESSO-01 (L8a): o escopo `módulo:ação`, ou a lista em que basta um. Com a chave ACESSO_GRANULAR ligada, decide no
  // lugar do `permissions`; desligada, ou sem escopo, o `permissions` decide, como hoje.
  escopos: {
    type: [String, Array],
    default: null,
  },
  featureFlag: {
    type: String,
    default: null,
  },
  installationTypes: {
    type: Array,
    default: null,
  },
});

const { shouldShow } = usePolicy();
const { ligado, pode } = useAcesso();

const temEscopos = computed(
  () => [props.escopos].flat().filter(Boolean).length > 0
);

// Sem escopo, nem se olha a chave: os usos de hoje ficam exatamente como estão. A flag e o tipo de instalação
// continuam valendo com a chave ligada: eles dizem se o módulo existe, e não quem o usa.
const show = computed(() => {
  if (temEscopos.value && ligado.value) {
    return (
      pode(props.escopos) &&
      shouldShow(props.featureFlag, [], props.installationTypes)
    );
  }
  return shouldShow(
    props.featureFlag,
    props.permissions,
    props.installationTypes
  );
});
</script>

<!-- eslint-disable vue/no-root-v-if -->
<template>
  <component :is="as" v-if="show">
    <slot />
  </component>
</template>
